export const createSportingHeaders = () => {
  const headers = new Headers();

  return headers;
};
